// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"188ca35e","787":"fbe75b9a"}[chunkId] + ".chunk.js";
};